import { Proj1 } from "./project/projects/proj1";
import { Proj2 } from "./project/projects/proj2";
import { Proj3 } from "./project/projects/proj3";
import { Proj4 } from "./project/projects/proj4";
import { Proj5 } from "./project/projects/proj5";
import { Proj6 } from "./project/projects/proj6";
import { Proj7 } from "./project/projects/proj7";
import { Proj8 } from "./project/projects/proj8";
import { Reveal } from "../../common/reveal";

export const Projects = () => {
  const projects = [Proj1, Proj2, Proj3, Proj4, Proj5, Proj6, Proj7, Proj8];

  return (
    <section id="projects" className="max-w-7xl mx-auto px-6 pb-10 py-2 scroll-mt-24 relative overflow-hidden" aria-label="Selected projects">
      {/* Floating pastel blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-pink-100/20 rounded-full blur-[120px] animate-pulse-slow" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-blue-100/20 rounded-full blur-[120px] animate-pulse-slow delay-2000" />
      </div>

      <Reveal>
        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-500 via-purple-400 to-pink-500">Selected Projects</h2>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-12 relative z-10">
        {projects.map((ProjectComp, i) => (
          <Reveal key={i}>
            <div className="rounded-xl overflow-hidden shadow-xl bg-white/0">
              <ProjectComp />
            </div>
          </Reveal>
        ))}
      </div>

      <style jsx>{`
        .animate-pulse-slow {
          animation: pulse 8s ease-in-out infinite;
        }
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.5;
          }
        }
      `}</style>
    </section>
  );
};
